export class NotifyType {
    email: boolean;
    mobile: boolean;
}
